export const fonts = {
  NanumEB: 'NanumSquare EB',
  NanumL: 'NanumSquare L',
  NanumR: 'NanumSquare R',
  NanumB: 'NanumSquare B',
  TypoS: 'Typo_S',
};
